export const buildAiComposerStyles = baseSelector => `
    ${baseSelector} p { margin: 0; }
    ${baseSelector} li > p, li > h1, li > h2, li > h3, li > h4, li > h5, li > h6 { display: inline; }
    ${baseSelector} ol, ul { list-style-position: inside; }
`;
export const CUSTOM_FONTS_CLASS = 'with-custom-fonts';
//# sourceMappingURL=aiComposerStyles.js.map